import React, { Component } from 'react';
import classes from './AccountStatus.css';
import { connect } from 'react-redux';
import ToggleSwitch from '../../../../UI/ToggleSwitch/ToggleSwitch';
import Modal from '../../../../UI/Modal/Modal';
import SelectPortal from '../../../../components/SelectPortal/SelectPortal';
import Spinner from '../../../../UI/Spinner/Spinner';
import * as actions from '../../../../store/actions/index';
import Message from '../../../../components/Message/Message';
import {isBasicMemberAccount, isPartialRegistration, isAccountDisabled, decodeBase64 } from '../../../../shared/utility';
import { LS_OTP_VERIFIED, SESSION_SUPERUSER, SESSION_READONLYUSER, SESSION_TIER1USER, HSID_PARTIAL_REGISTRATION, LOCKED, VERIFIED, RBA_OR_LDAP_LOCKED, RBA_OR_LDAP_UNLOCKED, RBA_PARTIAL_LOCKED, HSID_BASE, SESSION_SUPERVISORUSER, SESSION_BASELINEAGENT, BASE_LINE_AGENTS_RESTRICT_DELETE } from '../../../../shared/Constants';

export class AccountStatus extends Component {

    state = {
        showModal: false,
        id: null,
        showEnaDisableModal: false
    }

    toggleModal = (checked, event, id) => {
        this.setState({showModal: !this.state.showModal, id: !this.state.showModal?id:null});
    }

    submitHandler = (portalId, lang, elemId) => {
        let selectedPortal = this.props.portalsList.find(elem => elem.portalShortName+"" === portalId+"");
        const emailId = this.props.memberEsso.email.value;
        let userData = {
            uuid: this.props.memberEsso.uuid,
            userId: this.props.memberEsso.userName,
            emailId: emailId,
            portal: selectedPortal.portalShortName,
            brand: selectedPortal.portalBrandName,
            lang: lang,
            headlessUser: this.props.isHeadlessUser,
            isBaseAgentPortal: selectedPortal.isBaseAgentPortal
        };

        if(selectedPortal.isSdkPortal || selectedPortal.isBaseAgentPortal){
            userData = {
                ...userData,
                isSdkPortal : selectedPortal.isSdkPortal,
                targetUrl : selectedPortal.uiConfig.locales.en.targetUrl,
                hsidDomainUrl: selectedPortal.uiConfig.hsidDomainUrl,
                brandUrl: selectedPortal.uiConfig.brandUrl
            }
        }

        if(elemId === "ldap") {
            this.props.unlockUserStart();
            this.props.unlockUser(userData);
        } else if (elemId === "rba") {
            const rbaUserData = {
                ...userData,
                portalId: portalId,
                phone: this.props.memberEsso.phone && this.props.memberEsso.phone.number?this.props.memberEsso.phone.number:null,
                countryCode: this.props.memberEsso.phone && this.props.memberEsso.phone.countryCode ? this.props.memberEsso.phone.countryCode: null
            };
            this.props.unlockRbaStart();
            this.props.unlockRba(rbaUserData, this.props.idType);
        } else if (elemId === "esso") {
           // alert("this is enable disable save");
            //console.log("call here");
        }
        this.setState({showModal: !this.state.showModal});
    }

    doesRecoveryExist = () => {
        return (
            this.props.memberEsso.accountStatus.aaStatus === VERIFIED &&
            (
                (this.props.memberEsso.credential &&
                    this.props.memberEsso.credential.securityQuestionAndAnswers &&
                    this.props.memberEsso.credential.securityQuestionAndAnswers.length === 3)
                || (this.props.memberEsso.phone &&
                    this.props.memberEsso.phone.number)
            )
        )?true:false;
    }

    isRBALocked = (recoveryOptionExists) => {
        return this.props.memberEsso.accountStatus.aaStatus === LOCKED || !recoveryOptionExists?true:false;
    }

    componentDidMount(){
        if((!this.props.portalsList || !this.props.portalsList.length > 0) 
            && this.props.userType === SESSION_READONLYUSER) {
            this.props.fetchPortals(this.props.sdkPortalList);
        }
    }

    deleteAccountHandler = (checked, event, id) =>{
        //console.log("[Super User - Account Status] deleteAccountHandler", checked, event, id );
        event.preventDefault();
        let accountRecoveryRequest = null;
        let isRBALocked = false;
        const message = this.props.idType === HSID_PARTIAL_REGISTRATION? 'HSID-Partial Registration' : (isBasicMemberAccount(this.props.idType) ? 'HSID-Base Registration' : 'HealthSafeID');
        const uuid = this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid;
        const userName = this.props.member.essoData.userName;
        let text = "Are you sure you want to delete "+message+" for "+this.props.member.essoData.firstName+ " "+this.props.member.essoData.lastName+"?";
        if (this.props.idType === HSID_BASE) text = "Are you sure you want to delete "+message+" for "+userName+"?";
        if (this.isRBALocked(this.doesRecoveryExist())) {
            isRBALocked = true;
            accountRecoveryRequest = {
                email : this.props.member.essoData.email?.value,
                uuid : this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
                phoneAvailable : this.props.member.essoData.phone?.number ? true : false,
                securityQues : this.props.member.essoData.credential && this.props.member.essoData.credential.securityQuestionAndAnswers ? true : false,
                accStatus : this.props.member.essoData.accountStatus.aaStatus,
                userName : this.props.member.essoData.userName,
                headless: this.props.isHeadlessUser,
            };
        }
        if(window.confirm(text)) {
            const formData = {};
            formData.isRBALocked = isRBALocked;
            formData.provisionMemberId = this.props.member.provisionMemberId; // previously set to null
            formData.userName = this.props.member.essoData.userName;
            formData.emailId = this.props.member.essoData.email?.value;
            formData.secondaryEmail = this.props.member.essoData.secondaryEmail?.value;
            formData.uuid = uuid;
            formData.partialRegisterUser = isPartialRegistration(this.props.idType);
            formData.accountRecoveryRequest = accountRecoveryRequest;
            formData.baseHSID = isBasicMemberAccount(this.props.idType);
            formData.firstName = this.props.member.mdmFirstNm;
            formData.lastName = this.props.member.mdmLastNm;
            formData.dob = this.props.member.mdmDob;
            formData.portal = this.props.member.mbrRgstPrtlShrtNm;
            formData.enterpriseId = this.props.member.mdmMemberEid;
            this.props.deleteAccount(formData);
        }
     }

    render () {
        const modalWindow = this.state.showModal || this.props.processing?(
            <Modal show={this.state.showModal || this.props.processing} modalClosed={this.toggleModal}>
                {this.props.processing?<Spinner/>:
                <SelectPortal
                    modalTitle="Select portal and language"
                    elemId={this.state.id}
                    memberEsso = {this.props.memberEsso}
                    portalsList={this.props.portalsList}
                    portalsInfo = {this.props.portalsInfo}
                    closeModal={this.toggleModal}
                    submitHandler = {this.submitHandler}
                    agentUserType = {this.props.user.userType}
                    disabledPortals = {this.props.disabledPortals}
                />}
            </Modal>
        ):null;

        const ldapLock = this.props.memberEsso.essoStatus.ldapLockStatus === "unlocked" ? true : false;

        const recoveryOptionExists = this.doesRecoveryExist();

        const rbaLock = this.isRBALocked(recoveryOptionExists);
        const rbaOffText = this.props.memberEsso.accountStatus.aaStatus === LOCKED ? RBA_OR_LDAP_LOCKED: !recoveryOptionExists ? RBA_PARTIAL_LOCKED : RBA_OR_LDAP_LOCKED;
        // console.log("[Account Status] render recoveryOptionExists : ", rbaLock, recoveryOptionExists);
        const message = this.props.message?<Message msgType={this.props.message.type} info={this.props.message.info}/>:null;
        const deleteAccountMsg = this.props.deleteAccountMsg?<Message msgType={this.props.deleteAccountMsg.type} info={this.props.deleteAccountMsg}/>:null;
        const deleteAccountMsgBaselineAgent = <Message msgType={"Error"} info={{message: BASE_LINE_AGENTS_RESTRICT_DELETE}}/>;
        //console.log("Rbas status: " , rbaStatus , this.props.memberEsso.accountStatus.aaStatus,  this.props.memberEsso.credential,this.props.memberEsso.credential.securityQuestionAndAnswers.length, this.props.memberEsso.phone, this.props.memberEsso.phone.verified);
        // console.log("Account Status : " , this.props.memberEsso);
        const uuid = decodeBase64(localStorage.getItem(LS_OTP_VERIFIED))

        return (
            <div className={classes.AccountStatus}>
                {!(isPartialRegistration(this.props.idType) && this.props.userType === SESSION_BASELINEAGENT)&&
                <div className={classes.FormTitle}>Account Status</div>}
                {modalWindow}
                {message}
                {!(isPartialRegistration(this.props.idType) && 
                 (this.props.userType===SESSION_READONLYUSER ||
                 this.props.userType === SESSION_BASELINEAGENT)) &&
                <ToggleSwitch
                    id="ldap"
                    labelText="Username/Password Lock (LDAP Lock)"
                    status={ldapLock}
                    onText={RBA_OR_LDAP_UNLOCKED}
                    offText={RBA_OR_LDAP_LOCKED}
                    disabled={ldapLock || this.props.isHeadlessUser || this.props.idType===HSID_BASE || this.props.userType === SESSION_BASELINEAGENT || isAccountDisabled(this.props.memberEsso) || this.props.userType===SESSION_READONLYUSER}
                    clicked={this.toggleModal}
                    hideToggleButton = {this.props.userType === SESSION_READONLYUSER}
                />
                }
                <div className={classes.rbaToggle}>
                {!(isPartialRegistration(this.props.idType) && 
                 (this.props.userType===SESSION_READONLYUSER ||
                 this.props.userType === SESSION_BASELINEAGENT)) && 
                <ToggleSwitch
                    id="rba"
                    labelText="Phone # Lock (RBA Lock)"
                    status={!rbaLock}
                    onText={RBA_OR_LDAP_UNLOCKED}
                    offText={rbaOffText}
                    disabled={this.props.userType===SESSION_READONLYUSER || this.props.idType===HSID_BASE || this.props.userType === SESSION_BASELINEAGENT || !rbaLock
                        || (rbaLock && !(this.props.userType === SESSION_SUPERUSER || this.props.userType === SESSION_SUPERVISORUSER ||
                            (this.props.userType === SESSION_TIER1USER && this.props.member.essoData.uuid === uuid)
                        ) )
                        || isAccountDisabled(this.props.memberEsso)}
                    clicked={this.toggleModal}
                    isRBAToggle={this.props.userType!==SESSION_READONLYUSER &&
                        this.props.userType !== SESSION_BASELINEAGENT && this.props.idType!==HSID_BASE}
                    hideToggleButton = { this.props.userType=== SESSION_READONLYUSER}
                />
                }
                </div>
                <div>
                    {(this.props.userType===SESSION_SUPERUSER || this.props.userType === SESSION_TIER1USER || this.props.userType === SESSION_SUPERVISORUSER )
                     && this.props.isHSID? 
                        (<ToggleSwitch
                        id="deleteAccount"
                        labelText="Delete Account"
                        status={!this.props.deleteAccountStatus || isPartialRegistration(this.props.idType) || isBasicMemberAccount(this.props.idType)}
                        onText="Active"
                        offText="Deleted"
                        disabled={(this.props.deleteAccountStatus && !isPartialRegistration(this.props.idType)) || this.props.userType === SESSION_BASELINEAGENT 
                            || this.props.idType===HSID_BASE
                            || ((this.props.userType === SESSION_TIER1USER || this.props.userType === SESSION_SUPERVISORUSER) &&
                                  !isPartialRegistration(this.props.idType))
                            || ((this.props.userType === SESSION_TIER1USER || this.props.userType === SESSION_SUPERVISORUSER) &&
                            this.props.member.essoData.uuid !== uuid && isPartialRegistration(this.props.idType))
                            || isAccountDisabled(this.props.memberEsso)}
                        clicked={this.deleteAccountHandler}
                        />)
                        : ''
                    }{this.props.user.userType === SESSION_BASELINEAGENT? null: deleteAccountMsg}
                </div>
                
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        member: state.member.member,
        memberEsso: state.member.member.essoData,
        portalsList: state.personalInfo.portals,
        portalsInfo: state.personalInfo.portalsInfo,
        processing: state.member.accountStatusProcessing,
        message: state.member.accountStatusMessage,
        deleteAccountMsg: state.member.deleteAccountMsg,
        deleteAccountStatus: state.member.deleteAccountStatus,
        sdkPortalList: state.member.sdkPortalList,
        searchResult: state.search.searchResults,
        user: state.usr.user,
        disabledPortals: state.addEligibility.disabledPortals
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        unlockUserStart: () => dispatch(actions.unlockUserStart()),
        unlockUser: (userData) => dispatch(actions.unlockUser(userData)),
        unlockRbaStart: () => dispatch(actions.unlockRbaStart()),
        unlockRba: (userData, idType) => dispatch(actions.unlockRba(userData, idType)),
        enableDisableStart: () => dispatch(actions.enableDisableStart()),
        enableDisableAccount: (userData,flag) => dispatch(actions.enableDisableAccount(userData,flag)),
        fetchPortals: (sdkPortalList) => dispatch(actions.fetchMemberAccountPortals(sdkPortalList)),
        deleteAccount: (formData) => dispatch(actions.deleteAccount(formData))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountStatus);
